import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageService } from '../../service/message.service';
import { AuthenticationService, GoogleAnalyticsService } from 'app/core/service';
import { UserAuthenticatedDTO } from 'app/core/requests/UserAuthenticatedDTO';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from 'environments/environment';

export interface Message {
  type: string;
  message: string;
  timeStamp: string;
  noIcon?: boolean;
  noDateStamp?: boolean;
  titleInfoMessage?: true;
}

export interface BenAiResponse {
  content: string;
}

@Component({
  selector: 'benchat',
  templateUrl: './benchat.component.html',
  styleUrls: ['./benchat.component.scss'],
  providers: [TranslatePipe]
})
export class BenChatComponent {
  public profilePictureSrc = 'assets/images/avatars/no-user-image-icon.jpg';
  public benAiLogoSrc = 'assets/images/logo/logo-x-32x32.png';
  public isVisible = false;
  public currentUser: UserAuthenticatedDTO;
  public benAiGuidelinesUrl = environment.benAiGuidelinesUrl;
  isOpen = false;
  loading = false;
  messages: Message[] = [];
  chatForm = new FormGroup({
    message: new FormControl('', [Validators.required]),
  });
  @ViewChild('scrollMe') private myScrollContainer: any;
  private conversationId: string;

  constructor(
    private messageService: MessageService,
    private elementRef: ElementRef,
    private gAnalyticsService: GoogleAnalyticsService,
    private translate: TranslatePipe,
    private _authenticationService: AuthenticationService) {
    this._authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
      this.isVisible = user !== null;
    });
    this._authenticationService.currentUserInfo.subscribe(userInfo => {
      if (userInfo) {
        if (userInfo.profilePicturePhotoUrl) {
          this.profilePictureSrc = userInfo.profilePicturePhotoUrl;
        } else {
          this.profilePictureSrc = 'assets/images/avatars/no-user-image-icon.jpg';
        }
      }
    });

    const hour = this.getHour();

    this.messages.push({
      type: 'client',
      // eslint-disable-next-line max-len
      message: 'BENAI.MESSAGES.WELCOME_TITLE',
      noDateStamp: true,
      timeStamp: hour
    }, {
      type: 'client',
      message: 'BENAI.MESSAGES.WELCOME_DESCRIPTION',
      noIcon: true,
      timeStamp: hour
    }, {
      type: 'title',
      // sa ii schimb type in 'title'
      message: 'BENAI.MESSAGES.SAMPLE_TITLE',
      noDateStamp: true,
      noIcon: true,
      titleInfoMessage: true,
      timeStamp: hour
    }, {
      type: 'info',
      message: 'BENAI.MESSAGES.SAMPLE_BENEFIT_DIFFS',
      noDateStamp: true,
      noIcon: true,
      timeStamp: hour
    }, {
      type: 'info',
      message:'BENAI.MESSAGES.SAMPLE_WHY_TAXES',
      noDateStamp: true,
      noIcon: true,
      timeStamp: hour
    }, {
      type: 'info',
      message: 'BENAI.MESSAGES.SAMPLE_BEN_LOCATE',
      noDateStamp: true,
      noIcon: true,
      timeStamp: hour
    });
  }

  openSupportPopup() {
    this.isOpen = !this.isOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // Check if the clicked element is outside the modal
    const isOutsideClick = !this.elementRef.nativeElement.contains(event.target);

    if (isOutsideClick && this.isOpen) {
      this.isOpen = false;
    }
  }

  getHour() {
    const now = new Date();
    const hoursAndMinutes = now.getHours() + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes());

    return hoursAndMinutes;
  }

  onSampleMessageClick(message: Message) {
    if (message.type === 'info') {
      const translatedMessage = this.translate.transform(message.message);
      this.chatForm.setValue({ message: translatedMessage });
      this.sendMessage(translatedMessage);
    }
  }

  sendMessage(messageText?: string) {
    const hour = this.getHour();
    this.messages = this.messages.filter(m => m.type !== 'info' || 'title');
    const sentMessage = this.chatForm.value.message || messageText;
    this.loading = true;
    this.messages.push({
      type: 'user',
      message: sentMessage,
      timeStamp: hour
    });
    this.chatForm.reset();
    this.scrollToBottom();
    this.messageService.sendMessage(sentMessage).subscribe(
      {
        next: (response: BenAiResponse) => {
          this.loading = false;
          this.messages.push({
            type: 'client',
            message: response.content,
            timeStamp: this.getHour()
          });
          this.scrollToBottom();
        },
        error: (e) => { }
      });

    if (this.messages.filter(message => message.type === 'user').length === 1) {
      this.conversationId = crypto.randomUUID();
      // the user just sent the first message => a new conversation was started
      this.gAnalyticsService.addGeneralEventsAnalytics('event', 'benAI.new_conversation', {
        conversationId: this.conversationId
      });
    };
    this.gAnalyticsService.addGeneralEventsAnalytics('event', 'benAI.message_sent', {
      conversationId: this.conversationId
    });
  }

  scrollToBottom() {
    setTimeout(() => {
      try {
        this.myScrollContainer.nativeElement.scrollTop =
          this.myScrollContainer.nativeElement.scrollHeight + 500;
      } catch (err) { }
    }, 150);
  }
}
